// extracted by mini-css-extract-plugin
export default {"logo_box":"index_logo_box_8cfyB","logoBox2":"index_logoBox2_APzEK","logo_title":"index_logo_title_QzPGl","logo_finace":"index_logo_finace_T4MDe"};